<div class="mx-auto flex max-w-5xl flex-col">
  <div class="mb-4 h-8 w-8">
    <app-left-arrow-icon
      class="cursor-pointer"
      (click)="location.back()"
    ></app-left-arrow-icon>
  </div>

  <div>
    <h1 class="mb-4 text-2xl font-bold">License Change History</h1>
  </div>

  @if (errorFetchingLicense) {
    <div class="mt-4">
      <p class="text-error">{{ errorFetchingLicense }}</p>
    </div>
  } @else if (loadingLicense) {
    <div class="mt-4 text-center">
      <div class="loading loading-spinner"></div>
    </div>
  } @else if (!license || !tenant) {
    <div class="mt-4">
      <p class="text-error">No license or tenant data</p>
    </div>
  } @else {
    <div class="mb-4">
      <div class="flex justify-between space-x-8">
        <div>
          <div class="mb-2">
            <h4 class="text-md font-bold">Account Number</h4>
            <p class="text-sm">{{ tenant.account_number }}</p>
          </div>
          <div class="mb-2">
            <h4 class="text-md font-bold">Product</h4>
            <p class="text-sm">
              {{ license.product.code }} - {{ license.product.title }} ({{
                license.product.variance_code
              }})
            </p>
          </div>
          <div class="mb-2">
            <h4 class="text-md font-bold">Product Variant</h4>
            <p class="text-sm">{{ license.product_variant.description }}</p>
          </div>
        </div>
        <div>
          <div class="mb-2">
            <h4 class="text-md font-bold">Duration</h4>
            <p class="text-sm">
              {{ license.product_variant.display_duration }}
            </p>
          </div>
          <div class="mb-2">
            <h4 class="text-md font-bold">License Type</h4>
            <p class="text-sm">{{ getLicenseType(license) }}</p>
          </div>
          <div class="mb-2">
            <h4 class="text-md whitespace-nowrap font-bold">
              Price Lock Level
            </h4>
            <p class="text-sm">
              {{ license.product_variant.price_lock_level }}
            </p>
          </div>
          <div class="mb-2">
            <h4 class="text-md font-bold">Price</h4>
            <p class="text-sm">
              {{ getLicensePrice(license) | currency: 'USD' }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-4 border-base-content/50" />
  }

  @if (errorFetchingChangeLogs) {
    <div class="mt-4">
      <p class="text-error">{{ errorFetchingChangeLogs }}</p>
    </div>
  } @else if (loadingChangeLogs) {
    <div class="mt-4 text-center">
      <div class="loading loading-spinner"></div>
    </div>
  } @else {
    <div class="overflow-x-auto rounded-lg border border-base-content/20">
      <table class="table">
        <thead class="text-base font-medium">
          <tr>
            <td>Date</td>
            <td>Source</td>
            <td>Changed By</td>
            <td>Changes</td>
          </tr>
        </thead>
        <tbody>
          @for (entry of changeLogs; track entry.id) {
            <tr
              class="align-top"
              [ngClass]="$index % 2 === 0 ? 'bg-base-200/30' : 'bg-base-200'"
            >
              <td class="whitespace-nowrap">
                {{ entry.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
              </td>
              <td>{{ getChangeSourceLabel(entry.change_source) }}</td>
              <td>{{ getChangedByLabel(entry) }}</td>
              <td>
                <div class="space-y-1">
                  @for (summary of getChangeSummaries(entry); track summary) {
                    <div class="text-sm">{{ summary }}</div>
                  }
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="4" class="text-center">
                No change history for this license.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
